import { Paper, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import { Controller, useFormContext } from "react-hook-form";

import { useAuth } from "@/features/authentication";
import { OutletChartOfAccountSelect } from "@/features/outlet-chart-of-accounts";
import { CustomDatePicker, CustomInputField } from "@/features/ui";

import { CASH_BANK_ACCOUNT_TYPES } from "../other-payment-form-constants";

export const GeneralInformationSection = () => {
  const {
    control,
    register,
    formState: { errors },
  } = useFormContext();
  const { outlet } = useAuth();

  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Typography variant="h6" gutterBottom>
        Informasi Umum
      </Typography>

      <Grid container spacing={3}>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Controller
            name="cashBankOutletChartOfAccount"
            control={control}
            render={({ field, fieldState }) => (
              <OutletChartOfAccountSelect
                outletId={outlet?.id}
                types={CASH_BANK_ACCOUNT_TYPES}
                value={field.value}
                onChange={field.onChange}
                TextFieldProps={{
                  required: true,
                  label: "Kas/Bank",
                  error: fieldState.invalid,
                  helperText: fieldState.error?.message,
                  InputProps: {
                    placeholder: "Pilih Akun",
                  },
                }}
              />
            )}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Controller
            name="transactionDate"
            control={control}
            render={({ field, fieldState }) => (
              <CustomDatePicker
                value={field.value}
                onChange={field.onChange}
                required
                label="Tanggal"
                error={fieldState.invalid}
                helperText={fieldState.error?.message}
              />
            )}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <CustomInputField
            name="checkNumber"
            label="No Cek #"
            register={register}
            error={Boolean(errors.checkNumber)}
            helperText={errors.checkNumber?.message}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <CustomInputField
            name="payee"
            label="Penerima"
            register={register}
            error={Boolean(errors.payee)}
            helperText={errors.payee?.message}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6, lg: 8 }}>
          <CustomInputField
            name="note"
            label="Catatan"
            register={register}
            error={Boolean(errors.note)}
            helperText={errors.note?.message}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};
